<template>
  <div>
    <van-skeleton title animate :row="12" :round="true" :loading="loading_ske">
      <div class="mo08">
        <div class="mo09">
          <div class="mo11">
            <img :src="data.deviceCodeUrl" class="mo12" alt="">
          </div>
          <div class="mo13">
            <p class="mo15 text-overflow">设备名称：{{data.name}}</p>
            <p class="mo16 text-overflow">设备编号：{{data.deviceNo}}</p>
            <p class="mo16 text-overflow">设备型号：{{data.model}}</p>
            <p class="mo16 text-overflow">出厂日期：{{data.buyTime}}</p>
            <p class="mo16 text-overflow">所属车间：{{data.orgName}}</p>
<!--            <p class="mo16 text-overflow">设备管理员：{{data.adminName}}</p>-->
<!--            <p class="mo16 text-overflow">故障负责人：{{data.weixiuName}}</p>-->
          </div>
          <div class="mo14">
            <p class="mo15 text-overflow">所属公司：{{data.companyName}}</p>
            <p class="mo16 text-overflow">设备品牌：{{data.brand}}</p>
<!--            <p class="mo16 text-overflow">二维码链接：<a target="_blank" :href="data.deviceCodeUrl">{{data.deviceCodeUrl}}</a></p>-->
            <p class="mo16 text-overflow">使用年限：{{data.lifeage}}</p>
            <p class="mo16 text-overflow">生产人员：{{data.produceuserName}}</p>
            <p class="mo16 text-overflow">厂家联系方式：{{data.factorycontact}}</p>
          </div>
        </div>
        <div class="mo10 border-bottom">
          维修组
        </div>
        <div class="mo17">
          <div class="mo18 text-center" v-if="wxList.length == 0">
            <p class="mo21">暂无数据</p>
          </div>
          <div class="mo18" v-else>
            <p class="mo20" v-for="(item,index) in wxList" :key="index">{{item.userName}}（{{item.name}}）</p>
          </div>
        </div>
        <div class="mo10">
          保养项目
          <Icon type="md-add-circle" class="add01" @click="onModel1"/>
        </div>
      </div>
      <Table border ref="selection" :columns="columns7" :data="data6" :loading="loading"></Table>
      <div class="role05">
        <div class="role06">
          <Button type="info" @click="back">返回</Button>
        </div>
        <div class="role07">
          <Page :total="total" @on-change="nextPage"/>
        </div>
      </div>

      <Modal
        v-model="modal1"
        title="添加编辑保养项目"
        :mask-closable="false"
        @on-ok="add"
        @on-cancel="bigON">
        <Input v-model="name" placeholder="请输入名称">
          <span slot="prepend">名称</span>
        </Input>
        <Input v-model="xingh" placeholder="请输入型号" class="mod02">
          <span slot="prepend">型号</span>
        </Input>
        <Input v-model="brand" placeholder="请输入品牌" class="mod02">
          <span slot="prepend">品牌</span>
        </Input>
        <Input v-model="bianh" placeholder="请输入编号" class="mod02">
          <span slot="prepend">编号</span>
        </Input>
        <Input v-model="beizhu" placeholder="请输入备注" class="mod02">
          <span slot="prepend">备注</span>
        </Input>
        <Input v-model="zhouqi" placeholder="请输入保养周期" class="mod02">
          <span slot="prepend">时间/单位</span>
        </Input>
        <Input v-model="beijian" placeholder="请输入备件数量" class="mod02">
          <span slot="prepend">备件数量</span>
        </Input>
        <div class="mo06">
          <div class="mo07">
            <el-date-picker
              v-model="xcDate"
              type="date"
              class="mo05"
              placeholder="【下次保养时间】">
            </el-date-picker>
          </div>
          <div class="mo07">
            <el-date-picker
              v-model="txDate"
              type="date"
              class="mo05"
              placeholder="【提醒时间】">
            </el-date-picker>
          </div>
        </div>
      </Modal>
    </van-skeleton>
  </div>
</template>

<script>
  import httpDev from '@/api/device';
  import http from 'axios';
  import util from "../../util/util";
  export default {
    name: "devDetail",
    data(){
      return {
        columns7: [
          {
            title: '名称',
            key: 'partsName',
            render: (h, params) => {
              return h('div', [
                h('Icon', {
                  props: {
                    type: 'person'
                  }
                }),
                h('strong', params.row.partsName)
              ]);
            }
          },
          {
            title: '型号',
            key: 'model'
          },
          {
            title: '品牌',
            key: 'brand'
          },
          {
            title: '编号',
            key: 'deviceNo'
          },
          {
            title: '备件数量',
            key: 'num'
          },
          {
            title: '保养周期',
            key: 'cycledate'
          },
          {
            title: '上次保养时间',
            key: 'lastchangeDate'
          },
          {
            title: '下次保养时间',
            key: 'warrantyDate'
          },
          {
            title: '提醒时间',
            key: 'productionDate'
          },
          {
            title: '操作',
            key: 'action',
            width: 170,
            align: 'center',
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    icon:'ios-create-outline'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.edit(params.index)
                    }
                  }
                }, '编辑'),
                h('Button', {
                  props: {
                    type: 'error',
                    size: 'small',
                    icon:'md-close-circle'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.delLj(params.index)
                    }
                  }
                }, '删除'),
              ]);
            }
          }
        ],
        data6: [],
        data:[],              //设备信息
        ljData:[],            //零件数组
        loading_ske:true,     //骨架屏显示
        loading:false,        //是否加载
        xzid:'',              //选中的ID
        page:1,               //当前页
        pageSize:10,          //显示条数
        total:0,              //列表总数
        is_edit:false,        //是否为编辑模式
        sbid:'',              //当前设备ID
        name:'',              //零件名称
        xingh:'',             //型号
        bianh:'',             //编号
        gmDate:'',            //出厂日期
        byDate:'',            //保修日期
        brand:'',             //品牌
        modal1:false,         //是否显示选择模块
        wxList:[],            //维修组信息
        beizhu:'',            //备注
        zhouqi:'',            //周期
        beijian:'',           //备件数量
        xcDate:'',            //下次保养时间
        txDate:'',            //提醒时间
      }
    },
    created() {
      var me = this;
      if (me.$route.params.hasOwnProperty('sbid')) {
        me.sbid = me.$route.params.sbid;
      }
    },
    mounted() {
      var me = this;
      http.all([me.getLjList(),me.getDetail(),me.wxLists()]).then(http.spread(function (res1,res2,res3) {
        me.data6 = res1.data.dataList;
        me.data = res2.data.dataList[0];
        console.log(res2);
        if (res3.data.length > 0) {
          res3.data.forEach(function (item,index) {
            switch (item.state) {
              case 0:
                me.$set(item,'name','维修工');
                break;
              case 1:
                me.$set(item,'name','工程师');
                break;
              case 2:
                me.$set(item,'name','维修经理');
                break;
            }
          })
        }
        me.wxList = res3.data;
        me.loading_ske = false;
      }))
    },
    methods:{
      onModel1(){//添加保养项目
        var me = this;
        let menu = JSON.parse(sessionStorage.getItem('menu'));
        let is_auth =  util.is_Auth(menu,'设备管理','添加零件');
        if (is_auth == false) {
          me.$message.error('暂无权限');
          return false;
        }
        me.is_edit = false;
        me.modal1 = true;
      },
      bigON(){//关闭模态框
        var me = this;
        me.name = '';
        me.xingh = '';
        me.bianh = '';
        me.brand = '';
        me.gmDate = '';
        me.byDate = '';
        me.xzid = '';
        me.beizhu = '';
        me.zhouqi = '';
        me.beijian = '';
        me.xcDate = '';
        me.txDate = '';
      },
      edit(index){//点击编辑零件
        var me = this;
        let menu = JSON.parse(sessionStorage.getItem('menu'));
        let is_auth =  util.is_Auth(menu,'设备管理','编辑零件');
        if (is_auth == false) {
          me.$message.error('暂无权限');
          return false;
        }
        me.is_edit = true;
        let item = me.data6[index];
        console.log(item);
        me.name = item.partsName;
        me.xingh = item.model;
        me.bianh = item.deviceNo;
        me.brand = item.brand;
        me.txDate = item.productionDate;
        me.xcDate = item.warrantyDate;
        me.beizhu = item.remarks;
        me.zhouqi = item.cycledate;
        me.beijian = item.num;
        me.xzid = item.id;
        me.modal1 = true;
      },
      add(){//添加编辑零件
        var me = this;
        me.$Loading.start();
        if (me.name == '') {
          me.$message.error('请输入名称');
          me.$Loading.error();
          return false;
        }
        if (me.xingh == '') {
          me.$message.error('请输入型号');
          me.$Loading.error();
          return false;
        }
        if (me.brand == '') {
          me.brand = '暂未填写';
        }
        if (me.bianh == '') {
          me.bianh = '暂未填写';
        }
        if (me.beizhu == '') {
          me.beizhu = '暂未填写'
        }
        if (me.zhouqi == '') {
          me.zhouqi = '暂未填写'
        }
        if (me.beijian == '') {
          me.beijian = 0;
        }
        let user = JSON.parse(sessionStorage.getItem('user'));
        let data = {
          mobile:user.mobile,
          sign:user.sign,
          userId:'',
          companyId:user.companyId,
          deviceId:me.sbid,
          productionDate:me.txDate,
          warrantyDate:me.xcDate,
          name:me.name,
          deviceNo:me.bianh,
          lastchangeDate:'',
          model:me.xingh,
          brand:me.brand,
          remarks:me.beizhu,
          cycledate:me.zhouqi,
          num:me.beijian,
          type:1,
        }
        if (me.is_edit) {
          data['id'] = me.xzid;
        }
        httpDev.deviceaddparts(data).then(res => {
          console.log(res);
          switch (res.code) {
            case "0000":
              let data = {
                mobile:user.mobile,
                sign:user.sign,
                userId:user.userId,
                companyId:user.companyId,
                pageSize:me.pageSize,
                page:1,
                deviceid:me.sbid,
              }
              httpDev.devicepartslist(data).then(res => {
                me.data6 = res.data.dataList;
              })
              me.name = '';
              me.xingh = '';
              me.bianh = '';
              me.brand = '';
              me.beizhu = '';
              me.byDate = '';
              me.zhouqi = '';
              me.beijian = '';
              me.xcDate = '';
              me.txDate = '';
              if (me.is_edit) {
                me.$message.success('编辑成功');
              } else {
                me.$message.success('添加成功');
              }
              me.xzid = '';
              me.$Loading.finish();
              break;
            case "1111":
              me.$Loading.error();
              me.$message.error('添加失败');
              break;
          }
        })
      },
      nextPage(e){
        var me = this;
      },
      delLj(index){//删除零件
        var me = this;
        let menu = JSON.parse(sessionStorage.getItem('menu'));
        let is_auth =  util.is_Auth(menu,'设备管理','删除设备零件');
        if (is_auth == false) {
          me.$message.error('暂无权限');
          return false;
        }
        me.$confirm('此操作将删除该零件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          me.$Loading.start();
          let user = JSON.parse(sessionStorage.getItem('user'));
          let data = {
            partsId:'',
            sign: user.sign,
            mobile:user.mobile,
            deviceId:me.sbid,
            id:me.data6[index].id
          };
          httpDev.deleteparts(data).then(res => {
            switch (res.code) {
              case '0000':
                me.data6.splice(index,1);
                me.$message.success('删除成功');
                me.$Loading.finish();
                break;
              case '1111':
                me.$message.error('删除失败');
                me.$Loading.error();
                break;
            }
          })
        })
      },
      back(){//返回
        var me = this;
        me.$router.back();
      },
      getLjList(){//获取零件列表
        var me = this;
        let user = JSON.parse(sessionStorage.getItem('user'));
        let data = {
          mobile:user.mobile,
          sign:user.sign,
          userId:user.userId,
          companyId:user.companyId,
          pageSize:me.pageSize,
          page:1,
          deviceid:me.sbid,
        }
        return httpDev.devicepartslist(data);
        // httpDev.devicepartslist(data).then(res => {
        //   console.log(res);
        //   me.data6 = res.data.dataList;
        //   me.loading_ske = false;
        // })
      },
      getDetail(){
        var me = this;
        let user = JSON.parse(sessionStorage.getItem('user'));
        let data = {
          mobile:user.mobile,
          sign:user.sign,
          userId:user.userId,
          companyId:'',
          pageSize:me.pageSize,
          page:1,
          deviceId:me.sbid,
        }
        return httpDev.devicelist(data);
      },
      wxLists(){//获取维修组信息
        var me = this;
        let user = JSON.parse(sessionStorage.getItem('user'));
        let data = {
          mobile:user.mobile,
          sign:user.sign,
          companyId:user.companyId,
          deviceId:me.sbid,
        }
        return httpDev.wxList(data);
      }
    }
  }
</script>

<style scoped>
@import "device.css";
</style>